import React from 'react'
const remixiconUrl = `/assets/icon/remixicon.symbol.svg`;
export interface IEditorMenuItem { icon?: string, title?: string, action?: () => any, isActive?: () => boolean | null, type?: string }
const EditorMenuItem: React.FC<IEditorMenuItem> = ({ icon, title, action, isActive = null }) => (
  <button tabIndex={-1}
    className={`menu-item${isActive && isActive() ? ' is-active' : ''}`}
    onClick={action}
    title={title}
  >
    <svg className="remix">
      <use xlinkHref={`${remixiconUrl}#ri-${icon}`} />
    </svg>
  </button>
)

export default EditorMenuItem;